<template>
  <div>
    <group-card title="Pod List" icon="people" padded>
      <template slot="actions">
        <md-button
          class="md-icon-button md-primary md-simple new-app-button"
          @click="showNewPodDialog"
        >
          <md-icon
            id="new-app-icon"
          >note_add</md-icon>
          New Pod
          <md-tooltip md-direction="top">Add new pod</md-tooltip>
        </md-button>
        <loading-icon-button
          tooltip="Refresh"
          :loading="progress_indicator.pod_list"
          @click="refreshUserPods(true)"
        >
          refresh
        </loading-icon-button>
      </template>
      <!-- User Details Editor -->
      <md-dialog :md-active.sync="progress_indicator.edit_user_pod">
        <div class="dialogWrapper" v-if="!incomeTriggerDialog.show">
          <md-dialog-title>{{progress_indicator.dialog_title}}</md-dialog-title>
          <div class="md-layout">

            <!-- Pod Code -->
            <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
                                  label="Pod Code" v-model="new_user_pod.pod_code">
            </validated-text-input>

            <!-- Pod Name (Trading Name) -->
            <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
                                  label="Pod Name (Trading Name)" v-model="new_user_pod.name">
            </validated-text-input>

            <!-- Legal Entity Name -->
            <validated-text-input class="md-layout-item md-small-size-100 md-size-40"
                                  label="Legal Entity Name" v-model="new_user_pod.description">
            </validated-text-input>

            <!-- List of Possible Parent Pod list -->
            <md-field class="md-layout-item md-small-size-100 md-size-20">
                <label for="select">Select a Parent Pod</label>
                <md-select v-model="new_user_pod.parent_id" name="select">
                    <md-option value="none">None</md-option>
                    <md-option :value="user_pod.id" v-for="user_pod in selectableParentPods" :key="user_pod.id">{{ user_pod.name }}</md-option>
                </md-select>
            </md-field>

            <!-- Pod ABN -->
            <validated-number-input class="md-layout-item md-small-size-100 md-size-20"
              label="ABN"
              v-model="new_user_pod.pod_abn"
              integer
              maxLength="11"
              minLength="6"
              errormsg="Please enter a valid ABN between 6 and 11 characters in length"
            >
            </validated-number-input>

            <!-- ACN-->
            <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
                                  label="ACN" v-model="new_user_pod.acn">
            </validated-text-input>

            <!--Australian Credit Licence-->
            <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
                                  label="Australian Credit Licence" v-model="new_user_pod.acl">
            </validated-text-input>

            <!-- Pod Target -->
            <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
                                  label="Target" v-model="new_user_pod.pod_target">
            </validated-text-input>

            <!-- Business Address -->
            <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
                                  label="Business Address" v-model="new_user_pod.address">
            </validated-text-input>

            <!-- Pod Contact Name -->
            <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
                                  label="Pod Contact Name" v-model="new_user_pod.pod_contact_person">
            </validated-text-input>

            <!-- Pod Contact Email -->
            <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
                                  label="Pod Contact Email" v-model="new_user_pod.pod_contact_email">
            </validated-text-input>

            <!-- Pod Contact Phone -->
            <validated-text-input
              class="md-layout-item md-small-size-100 md-size-20"
              label="Pod Contact Phone"
              v-model="new_user_pod.contact_number"
              prefix="+"
              :minLength=7
              :maxLength=15
              regex = "^\d+$"
              errormsg="Please enter a valid phone number, format can contain 7 to 15 digits"
            />

            <!-- Pod Bank BSB-->
            <validated-number-input class="md-layout-item md-small-size-100 md-size-10"
              label="Pod Bank BSB"
              v-model="new_user_pod.bsb"
              digits="6"
              errormsg="Please enter a valid BSB. It should be 6 digits in length"
            >
            </validated-number-input>

            <!-- Pod Bank Account Number-->
            <validated-text-input class="md-layout-item md-small-size-100 md-size-15"
                                  label="Pod Bank Account Number" v-model="new_user_pod.account_number">
            </validated-text-input>


            <!-- Pod Status -->
            <validated-autocomplete-input class="md-layout-item md-small-size-50 md-size-10"
                                          label="Pod Status" v-model="new_user_pod.pod_status"
                                          :options="['Active', 'Inactive']"
            />

            <search-text-input class="md-layout-item md-size-25"
                              label="Xero Contact ID"
                              v-model="new_user_pod.xero_contact_code"
                              :searcher="searchContactId"
                              @select="setPodContactId"
                              min-length="2"
                              clearable
            >
              <template v-slot="{ item }">
                {{ item.name }}
              </template>
            </search-text-input>

            <md-checkbox
            class="md-layout-item md-size-20"
            v-model="new_user_pod.bill_in_bulk"
            >
              Bill In Bulk
            </md-checkbox>

            <md-checkbox
              class="md-layout-item md-size-20"
              v-model="new_user_pod.birdeye_enable"
            >
              BirdEye Enabled?
            </md-checkbox>

            <validated-text-input class="md-layout-item md-small-size-100 md-size-20"
              label="BirdEye URL" v-model="new_user_pod.birdeye_url">
            </validated-text-input>

            <!-- Broker Pod Owner -->
            <search-text-input class="md-layout-item md-size-25"
                              label="Broker Pod Owner"
                              v-model="selectedPodOwner"
                              :searcher="searchPodOwnerId"
                              @select="setPodOwnerId"
                              min-length="2"
                              clearable
            >
              <template v-slot="{ item }">
                {{ item.first_name + ' ' + item.last_name}}
              </template>
            </search-text-input>

            <!-- Broker Pod Local Lead Radius -->
            <validated-number-input class="md-layout-item md-small-size-100 md-size-20"
              label="Broker Pod Local Lead Radius" v-model="new_user_pod.local_radius"
              errormsg="Please enter a valid number between 2-3 digits."
              maxLength="3"
              minLength="2">
            </validated-number-input>

          </div>
          <!-- Broker Pod Trigger & Rates -->
          <div class="md-layout" style="padding-top: 20px;">
            <div class="boxed-category md-layout-item">
              <md-subheader>
                Broker Pod Trigger & Rates
              </md-subheader>
              <div class="md-layout-item">
                <div class="md-layout md-gutter md-alignment-center-left trigger-button" v-if="showIncomeTriggerButton">
                  <md-button
                    class="md-primary md-layout-item md-size-15"
                    @click="configCustomTriggers(new_user_pod.id)"
                  >
                      Config Custom Trigger
                  </md-button>
                  <div class="md-layout-item md-size-25">
                    <p>{{ customTriggerCountText(new_user_pod.income_trigger_count) }}</p>
                  </div>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field>
                      <label for="trigger-one-field">Trigger 1</label>
                      <md-input id="trigger-one-field"
                                v-model="new_user_pod.trigger_1"/>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label for="rate-one-field">Rate 1</label>
                      <md-input id="rate-one-field"
                                v-model="new_user_pod.rate_1"/>
                    </md-field>
                  </div>
                </div>
                <br>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field>
                      <label for="trigger-two-field">Trigger 2</label>
                      <md-input id="trigger-two-field"
                                v-model="new_user_pod.trigger_2"/>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label for="rate-two-field">Rate 2</label>
                      <md-input id="rate-two-field"
                                v-model="new_user_pod.rate_2"/>
                    </md-field>
                  </div>
                </div>
                <br>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field>
                      <label for="trigger-three-field">Trigger 3</label>
                      <md-input id="trigger-three-field"
                                v-model="new_user_pod.trigger_3"/>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label for="rate-three-field">Rate 3</label>
                      <md-input id="rate-three-field"
                                v-model="new_user_pod.rate_3"/>
                    </md-field>
                  </div>
                </div>
                <br>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field>
                      <label for="trigger-four-field">Trigger 4</label>
                      <md-input id="trigger-four-field"
                                v-model="new_user_pod.trigger_4"/>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label for="rate-four-field">Rate 4</label>
                      <md-input id="rate-four-field"
                                v-model="new_user_pod.rate_4"/>
                    </md-field>
                  </div>
                </div>
                <br>
              </div>
            </div>
          </div>
          <div class="md-layout">
            <div class="boxed-category md-layout-item">
              <md-subheader>
                Webhook
              </md-subheader>
              <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field>
                      <label for="webhook_url">Webhook URL</label>
                      <md-input
                        id="webhook_url"
                        v-model="new_user_pod.webhook_url"/>
                    </md-field>
                  </div>
                </div>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-20">
                    <md-field>
                      <label for="webhook_schema">Schema</label>
                      <md-select v-model="new_user_pod.webhook_schema" name="webhook_schema" id="webhook_schema" multiple>
                        <md-option value="update-lead">Update Lead</md-option>
                      </md-select>
                    </md-field>
                  </div>
                </div>
                <div>
                  <strong>Selected fields:</strong>
                  {{ new_user_pod.webhook_schema }}
                </div>
                <br>
              </div>
            </div>
          </div>
          <!-- Broker Pod VBI Trigger & Rates -->
          <div class="md-layout">
            <div class="boxed-category md-layout-item">
              <md-subheader>
                Broker Pod VBI Trigger & Rates
              </md-subheader>
              <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field>
                      <label for="trigger-one-field">Trigger 1</label>
                      <md-input id="trigger-one-field"
                                v-model="new_user_pod.vbi_trigger_1"/>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label for="rate-one-field">VBI Rate 1</label>
                      <md-input id="rate-one-field"
                                v-model="new_user_pod.vbi_rate_1"/>
                    </md-field>
                  </div>
                </div>
                <br>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field>
                      <label for="trigger-two-field">VBI Trigger 2</label>
                      <md-input id="trigger-two-field"
                                v-model="new_user_pod.vbi_trigger_2"/>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label for="rate-two-field">VBI Rate 2</label>
                      <md-input id="rate-two-field"
                                v-model="new_user_pod.vbi_rate_2"/>
                    </md-field>
                  </div>
                </div>
                <br>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field>
                      <label for="trigger-three-field">VBI Trigger 3</label>
                      <md-input id="trigger-three-field"
                                v-model="new_user_pod.vbi_trigger_3"/>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label for="rate-three-field">Rate 3</label>
                      <md-input id="rate-three-field"
                                v-model="new_user_pod.vbi_rate_3"/>
                    </md-field>
                  </div>
                </div>
                <br>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field>
                      <label for="trigger-four-field">VBI Trigger 4</label>
                      <md-input id="trigger-four-field"
                                v-model="new_user_pod.vbi_trigger_4"/>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label for="rate-four-field">Rate 4</label>
                      <md-input id="rate-four-field"
                                v-model="new_user_pod.vbi_rate_4"/>
                    </md-field>
                  </div>
                </div>
                <br>
              </div>
            </div>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary md-simple" @click="onEditUserCancel">Cancel</md-button>
            <md-button class="md-primary md-simple" @click="createUserPod">Save</md-button>
          </md-dialog-actions>
        </div>
      </md-dialog>
      <PodList
        :items="user_pods"
        :loading="progress_indicator.pod_list"
        @delete-pod="removeUserPod"
        @open-pod="editUserPod"
        @edit-lenders="editAvailableLenders"
      ></PodList>
    </group-card>
    <div>
      <md-dialog :md-active.sync="progress_indicator.edit_lenders">
        <div class="dialogWrapper">
          <md-dialog-title>{{ progress_indicator.dialog_title }}</md-dialog-title>
          <div class="checkbox-options">
            <md-button class="md-success" @click="selectAllLenderPods(true)">Select All</md-button>
            <md-button class="md-danger" @click="selectAllLenderPods(false)">Unselect All</md-button>
          </div>
          <md-subheader>Consumer</md-subheader>
          <div class="md-layout input-layout">
            <div v-for="lender in lenderPods.consumer" :key="lender.id">
              <md-checkbox v-model=lender.enable class="md-layout-item">{{ lender.lender_name }}</md-checkbox>
            </div>
          </div>
          <md-subheader>Commercial</md-subheader>
          <div class="md-layout input-layout">
            <div v-for="lender in lenderPods.commercial" :key="lender.id">
              <md-checkbox v-model=lender.enable class="md-layout-item">{{ lender.lender_name }}</md-checkbox>
            </div>
          </div>
          <md-subheader>Personal</md-subheader>
          <div class="md-layout input-layout">
            <div v-for="lender in lenderPods.personal" :key="lender.id">
              <md-checkbox v-model=lender.enable class="md-layout-item">{{ lender.lender_name }}</md-checkbox>
            </div>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary" @click="onEditLenderPodsCancel">Cancel</md-button>
            <md-button class="md-primary" @click="updateLenderPods">Save</md-button>
          </md-dialog-actions>
        </div>
      </md-dialog>
    </div>

    <!--Income Trigger Dialog-->
    <income-trigger-configuration-dialog
      :show.sync="incomeTriggerDialog.show"
      :income-triggerable-type="incomeTriggerDialog.type"
      :income-triggerable-id="incomeTriggerDialog.id"
      @close-trigger-dialog="closeIncomeTriggerDialog"
    />

  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import filters from "@/components/utils/filters";
import ValidatedInputs from '@/components/ValidatedInput';
import LoadingIconButton from '@/components/LoadingIconButton';
import {GroupCard} from "@/components";
import PodList from "../components/PodList";
import {newPod} from "../schema";
import WaitingDialog from "../components/Dialogs/WaitingDialog";
import ConfirmDialog from "../components/Dialogs/ConfirmDialog";
import IncomeTriggerConfigurationDialog from '../components/Dialogs/IncomeTrigger/IncomeTriggerConfigurationDialog.vue';

export default {
  components: {
    PodList,
    ...ValidatedInputs,
    LoadingIconButton,
    GroupCard,
    WaitingDialog,
    ConfirmDialog,
    IncomeTriggerConfigurationDialog,
  },
  data() {
    return {
      user_pods: [],
      progress_indicator: {
        pod_list: false,
        remove_user_pod_id: null,
        edit_user_pod: false,
        edit_user_pod_id: null,
        edit_lenders: false,
        dialog_title: 'New Pod',
      },
      selectedPodOwner: "",
      new_user_pod: newPod(),
      contactIdSearch: {
        query: null,
        results: null,
        searching: false
      },
      podOwnerIdSearch: {
        query: null,
        results: null,
        searching: false
      },
      lenderPods: {
        consumer: [],
        commercial: [],
        personal: [],
      },
      incomeTriggerDialog: {
        show: false,
        id: null,
        type: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      savedPods: 'administrationPods',
    }),
    showIncomeTriggerButton() {
      return this.new_user_pod && this.new_user_pod.id != null;
    },
    selectableParentPods() {
        return this.user_pods.filter(user_pod => {
            return user_pod.parent_id == null;
        });
    }
  },
  methods: {
    async searchContactId(query) {
      this.contactIdSearch.searching = true;
      let {data} = await this.$store.dispatch('get_xero_contacts', query);
      return data;
    },
    setPodContactId(contact) {
      this.new_user_pod.xero_contact_code = contact.contact_id;
    },
    async searchPodOwnerId(query) {
      this.podOwnerIdSearch.searching = true;
      let {data} = await this.$store.dispatch('search_user', query);
      return data;
    },
    setPodOwnerId(user) {
      this.new_user_pod.pod_owner_id = user.id;
      this.selectedPodOwner = user.first_name + ' ' + user.last_name
    },
    showNewPodDialog(){
      //clear the object
      this.new_user_pod = newPod();
      //set the tile
      this.progress_indicator.dialog_title = 'New Pod';
      //show the dialog
      this.progress_indicator.edit_user_pod = true;
    },
    onEditUserCancel(){
      this.progress_indicator.edit_user_pod = false;
    },
    async refreshUserPods(force=false){
      this.progress_indicator.pod_list = true;

      let status = await this.$store.dispatch('fetch_administration_user_pods', force);

      if(status){
        this.user_pods = this.savedPods();
      }else{
        console.log('Error fetching user pods.');
      }

      this.progress_indicator.pod_list = false;
    },
    async createUserPod(){
      try{
        const result = await axios.post(`/api/v1/administration/user_pods`, this.new_user_pod);
        const newPod = result.data;
        await this.editAvailableLenders(newPod);
        await this.refreshUserPods();
      }catch(error){
          console.error('User Pod creation request failed');
          console.error(error);
      }

      this.progress_indicator.edit_user_pod = false;
      this.refreshUserPods(true);
    },
    async removeUserPod(user_pod){
      const response = await this.$modal.show(ConfirmDialog, {
        title: "Delete POD",
        message: `Do you wish to delete pod ${user_pod.name}`,
        important: "",
        confirmText: "Sure",
        cancelText: 'Cancel',
      });

      if(!response) {
        return false;
      }

      this.progress_indicator.pod_list = true;

      try{
        await axios.delete(`/api/v1/administration/user_pods/${user_pod.id}`);
        await this.refreshUserPods();

      }catch(error){
          console.error('User Pod delete request failed');
          console.error(error);
      }
      this.refreshUserPods(true);
    },
    async editUserPod(user_pod){
      this.new_user_pod = user_pod;
      this.loadPodOwner(this.new_user_pod.pod_owner_id);
      this.progress_indicator.dialog_title = `Edit User Pod. ${user_pod.id}`;
      this.progress_indicator.edit_user_pod = true;
    },
    async editAvailableLenders(user_pod) {
      // fetch lenders
      this.showProcessDialog("Fetching", "Please wait whilst retrieving lenders...", "waiting");
      try {
        const response = await axios.get("/api/v1/administration/user_pods/lenders", {"params": {"id": user_pod.id}});
        const lenders = response.data;
        this.lenderPods.consumer = lenders.filter(lender => lender["type"] === "Consumer");
        this.lenderPods.commercial = lenders.filter(lender => lender["type"] === "Commercial");
        this.lenderPods.personal = lenders.filter(lender => lender["type"] === "Personal");
        this.progress_indicator.dialog_title = `Edit Available Lenders For Pod. ${user_pod.name}`;
        this.progress_indicator.edit_lenders = true;
      } catch (error) {
        console.log(error);
      }
      if (this.$modal.submit) {
        this.$modal.submit();
      }
    },
    onEditLenderPodsCancel() {
      this.progress_indicator.edit_lenders = false;
    },
    async updateLenderPods() {
      const lenderPods = [...this.lenderPods.consumer, ...this.lenderPods.commercial, ...this.lenderPods.personal];
      this.showProcessDialog("Updating", "Updating Available Lenders...", "waiting");
      try {
        await axios.post("/api/v1/administration/user_pods/lenders", {"lenders": lenderPods});
        if (this.$modal.submit) {
          this.$modal.submit();
          await this.showProcessDialog("Success", "Available Lenders have been updated.", "confirm");
        }
      } catch (error) {
        if (this.$modal.submit) {
          this.$modal.submit();
          await this.showProcessDialog("Fail", "Fail to update available Lenders", "confirm");
        }
        console.log(error);
      } finally {
        this.progress_indicator.edit_lenders = false;
      }
    },
    selectAllLenderPods(isChecked = true) {
      Object.values(this.lenderPods).forEach(lenderPod => {
        Object.values(lenderPod).forEach(lender => lender.enable = isChecked);
      });
    },
    async showProcessDialog(title, message, type = "waiting") {
      if (type == "waiting") {
        this.$modal.show(WaitingDialog, {
          title: title,
          message: message,
        });
      }
      if (type == "confirm") {
        this.$modal.show(ConfirmDialog, {
          title: title,
          message: message,
          confirmText: "Close",
        })
      }
    },
    async loadPodOwner(podOwnerId) {
      try {
        if(podOwnerId) {
          const { data } = await this.$store.dispatch('fetch_user_by_id', podOwnerId);
          this.selectedPodOwner = `${data.first_name} ${data.last_name}`;
        } else {
          this.selectedPodOwner = '';
        }
      } catch (error) {
        console.error('Failed to load pod owner:', error);
      }
    },
    configCustomTriggers(user_pod_id) {
        if (user_pod_id == null) {
          return;
        }
        this.incomeTriggerDialog.show = true;
        this.incomeTriggerDialog.id = user_pod_id;
        this.incomeTriggerDialog.type = 'pod';
    },
    closeIncomeTriggerDialog (value) {
      this.incomeTriggerDialog.show = false;
      this.incomeTriggerDialog.id = null;
      this.incomeTriggerDialog.type = '';
      this.new_user_pod.income_trigger_count = value;
    },
    customTriggerCountText (income_trigger_count) {
      if (income_trigger_count == 0 || income_trigger_count == null) {
        return 'No Custom Triggers';
      }
      return '[' + income_trigger_count + '] Custom Triggers'
    },
  },
  async created(){
    this.refreshUserPods();
  },
  filters: {
    ...filters,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/theme.scss";
  .dialogWrapper {
    overflow: scroll;
    padding-top: 15px;
  }
  .checkbox-options {
    margin-left: 20px;
  }

  .trigger-button {
    padding-left: 20px;
  }
</style>
